import DocumentEditor from './components/LandingPageEditor';
import DocumentPreview from './components/LandingPagePreview';
import Icon from './LandingPages.icon';
import Page from './LandingPage.page';
import LandingPageLayout from './LandingPage.layout';

export default {
  DocumentEditor,
  DocumentPreview,
  Icon,
  CustomPage: Page,
  CustomLayout: LandingPageLayout,
  stringifyContent: (templateContent) => `Heading: ${templateContent.heading}
  Slogan: ${templateContent.slogan}
  Subheading: ${templateContent.subheading}
  Benefit 1: ${templateContent.benefit1}
  Benefit 1 description: ${templateContent.benefit1_description}
  Benefit 2: ${templateContent.benefit2}
  Benefit 2 description: ${templateContent.benefit2_description}
  Benefit 3: ${templateContent.benefit3}
  Benefit 3 description: ${templateContent.benefit3_description}
 `,
};
